
import { Component, Vue, Prop, Model, Watch } from 'vue-property-decorator';

@Component
export default class LimitBuyField extends Vue {
  labelCol = { span: 6 };
  wrapperCol = { span: 14 };

  formData = {
    dailyLimitBuy: '',
    limitBuy: '',
  };

  @Prop()
  placeholder?: string;

  @Prop()
  refs!: any;

  @Prop()
  readonly!: boolean;

  @Prop()
  disabled!: boolean;

  @Model('change')
  value!: any;


  @Watch('value')
  watchValue() {
   const { dailyLimitBuy, limitBuy } = this.value;
   this.formData.dailyLimitBuy = dailyLimitBuy;
   this.formData.limitBuy = limitBuy;
  }

  changeInput() {
    this.$emit('update', this.formData);
  }


  mounted() {
    this.watchValue();
  }
}
